<template>
  <RichtextResolver :blok="blok">
    <template #component="{ node }">
      <StoryblokComponent
        v-for="(body, index) of node.attrs.body"
        :id="node.attrs.id"
        :key="index"
        :blok="body"
      />
    </template>
    <template #image="{ node }">
      <NuxtImg
        class="image"
        format="webp"
        placeholder
        :src="node.attrs.src.replace('//a.storyblok.com', '//assets.pflege.de')"
        :alt="node.attrs.alt"
        :title="node.attrs.title"
        :data-copyright="node.attrs.copyright"
        loading="lazy"
      />
    </template>
  </RichtextResolver>
</template>
<script lang="ts" setup>
import { type BlokProps } from '@webcarelbj/shared-bloks'
import { type RichtextContent, type RichtextResolverSlots } from '@webcarelbj/shared-components'

defineProps<BlokProps<RichtextContent>>()
defineSlots<RichtextResolverSlots>()

</script>
<style lang="scss" scoped>
img {
  max-width: 100%;
}
</style>
